import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import { P_API_ASSETS, getConfig } from 'utils';

export async function deleteAsset(id: string): Promise<void> {
  assertClientSide();

  const config = await getConfig();
  await axios.delete(`${P_API_ASSETS}/${id}`, {
    headers: { 'csrf-token': config.CSRF },
  });
}
